import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { InvoiceInterface } from '@app/interface/invoice';

@Injectable({
  providedIn: 'root',
})
export class ArubaService extends BaseAuthenticatedService {
  private apiUrl = environment.backendDomain;

  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient
  ) {
    super(auth, httpClient);
  }

  // generateInvoiceXml(invoiceId: number): Observable<Blob> {
  //   const headers = new HttpHeaders({
  //     Accept: 'application/xml',
  //   });

  //   console.log(invoiceId);

  //   return this.http.get(`${this.apiUrl}/${invoiceId}/generate-xml/`, {
  //     headers: headers,
  //     responseType: 'blob', // Important for file downloads
  //   });
  // }

  // Generate XML (returns Blob for file download)
  // generateInvoiceXml(invoiceId: number): Observable<Blob> {
  //   return this.http.get(`${this.apiUrl}/invoices/${invoiceId}/generate-xml/`, {
  //     responseType: 'blob', // Important for file downloads
  //   });
  // }

  // // Upload to Aruba
  // uploadInvoiceToAruba(invoiceId: number): Observable<any> {
  //   return this.http.post(
  //     `${this.apiUrl}/invoices/${invoiceId}/upload-to-aruba/`,
  //     {}
  //   );
  // }

  // Combined endpoint (optional)
  // generateAndUploadInvoice(
  //   invoiceData: Partial<InvoiceInterface>
  // ): Observable<InvoiceInterface> {
  //   // return this.http.post(
  //   //   `${this.apiUrl}/invoices/${invoiceId}/generate-and-upload/`,
  //   //   {}
  //   // );

  //   let invoice_id = 1;

  //   if (!invoiceData.id) {
  //     invoiceData.company_id = 1; // invoiceData.company_id
  //   } else {
  //     invoice_id = invoiceData.id;
  //   }

  //   const path = `invoices/${invoice_id}/generate-and-upload/`;

  //   return this.post<InvoiceInterface>(path, {}, invoiceData);
  // }
}
